import { arrayHasItems } from "../../../helpers/common"
import { ListOfLogItem } from "./ListOfLogItem"

export const ListOfLogs = ({
    list
}) => {
    return (
        <div className="mt-3 space-y-2">
            {!arrayHasItems(list) ? (
                <div className="rounded-md border border-dashed border-border bg-white px-4 py-6 text-sm text-gray-600">
                    No decision history matches the current filters yet.
                </div>
            ) : (
                <>
                    {list.map((listItem) => {
                        return (
                            <div className="rounded-md border border-border bg-white p-3" key={listItem.id}>
                                <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
                                    <div className="flex flex-wrap items-center gap-2">
                                        <span className="bg-gray-50 border border-gray-200 text-primary text-xs font-medium px-2 py-1 rounded-lg">
                                            {listItem.groupName}
                                        </span>
                                        {listItem.isApproved && (
                                            <span
                                                className="inline-flex items-center justify-center border w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-primary/90 rounded-md px-2 py-1 text-[10px] font-medium shadow-none border-transparent bg-emerald-50 text-emerald-700"
                                            >
                                                Approved
                                            </span>
                                        )}
                                        {listItem.isDissmissed && (
                                            <span
                                                className="inline-flex items-center justify-center border w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-primary/90 rounded-md px-2 py-1 text-[10px] font-medium shadow-none border-transparent bg-slate-100 text-slate-700"
                                            >
                                                Dismissed
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <p className="text-sm font-medium text-primary">
                                    {listItem.canonicalName || ""}
                                </p>
                                <p className="mt-1 text-sm leading-6 text-gray-600">
                                    {listItem.description || ""}
                                </p>
                                <div className="mt-3 grid gap-2 text-xs text-gray-600 sm:grid-cols-2">
                                    <ListOfLogItem
                                        label="Subcategory"
                                        value={listItem.subcategory || ""}
                                    />
                                    <ListOfLogItem
                                        label="Timestamp"
                                        value={listItem.timestamp || ""}
                                    />
                                    <ListOfLogItem
                                        label="Planner context"
                                        value={listItem.plannerContext || ""}
                                    />
                                    <ListOfLogItem
                                        label="Before → after"
                                        value={listItem.beforeAfter || ""}
                                    />
                                </div>
                            </div>
                        )
                    })}
                </>
            )}               
        </div>
    )
}